import React from 'react';
import './ToolActivityIndicator.css';

/** Shows what the agent is doing while a tool runs. Label comes from the server. */
const ToolActivityIndicator = ({ label }) => (
    <div className='tool-activity'>
        <span className='tool-activity__spinner' aria-hidden='true' />
        <span className='tool-activity__label'>{label}…</span>
    </div>
);

export default ToolActivityIndicator;
